import template from './myLoansCard.html';
import controller from './myLoansCard.controller';
import './myLoansCard.scss';

let myLoansCardComponent = {
  restrict: 'E',
  bindings: {
    loanObject: '<',
    viewOptions: '<',
    onToggleOptions: '&',
    onChangeOptionSelected: '&',
    onSelectOption: '&',
    onJustification: '&',
    serviceClosed: '<',
    filterActive: '<',
    tempLoanObject: '<',
  },
  template,
  controller,
};

export default myLoansCardComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/myLoans/myLoansCard/myLoansCard.component.js